import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type {
  ContentSectionConfig,
  ContentTopic,
} from "../../@types/portalAluno";
import { getSectionTopics } from "../../services/portalAluno/topics/topicsService";
import type { ApplicationState } from "../../store";

export const portalTopicsQueryKey = (
  idUsuario?: number,
  topicType?: string
) => ["portal-aluno", "temas", idUsuario, topicType];

const useContentTopics = (section?: ContentSectionConfig) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;

  return useQuery<ContentTopic[]>({
    enabled: Boolean(idUsuario && section),
    queryKey: portalTopicsQueryKey(idUsuario, section?.topicType),
    queryFn: () => getSectionTopics(section as ContentSectionConfig),
    staleTime: 30 * 1000,
  });
};

export default useContentTopics;
